import React from 'react';
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';
import LineChart from 'recharts/lib/chart/LineChart';
import Line from 'recharts/lib/cartesian/Line';
import XAxis from 'recharts/lib/cartesian/XAxis';
import YAxis from 'recharts/lib/cartesian/YAxis';
import CartesianGrid from 'recharts/lib/cartesian/CartesianGrid';
import Tooltip from 'recharts/lib/component/Tooltip';
import Legend from 'recharts/lib/component/Legend';
import ReferenceLine from 'recharts/lib/cartesian/ReferenceLine';
 
import { connect } from "react-redux";
 
function SpeedChart(props) {
  let str =  props.pos;
  return (
    // 99% per https://github.com/recharts/recharts/issues/172
    <ResponsiveContainer width="99%" height="80%">

      <LineChart data={props.vehicles} syncId="anyId">
        <XAxis label="Time" dataKey="timestamp" tick={false} />
        <YAxis />
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <Tooltip />
        {/* <Legend  /> */}
        <ReferenceLine  x={str} stroke="red"  />
        <Line type="monotone" dataKey="speed" stroke="#82ca9d" />
      </LineChart>
    </ResponsiveContainer>
  );
}


const mapStateToProps = (state) => {
  return { 
    vehicles: state.vehicles
  }
}

export default connect(mapStateToProps)(SpeedChart);
